/**
 * Pollo Sora 2：input 结构单独封装
 * 图生：image 必填，length 4|8|12（必填），prompt 1-4000，aspectRatio 16:9|9:16
 * 文生：prompt 必填，length 4|8|12，aspectRatio 16:9|9:16
 */
import { isUrl } from './utils'

/** UI 为 10s/15s，接口为 4|8|12：10→8，15→12 */
function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 4
  if (num === 10) return 8
  if (num === 15) return 12
  if (num <= 4) return 4
  if (num <= 8) return 8
  return 12
}

function normalizeAspectRatio(v) {
  var s = (v || '16:9').replace(/：/g, ':').trim()
  return s === '9:16' ? '9:16' : '16:9'
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 4000),
    length: normalizeLength(params.videoDuration || params.length || 4),
    aspectRatio: normalizeAspectRatio(params.aspectRatio)
  }
  if (hasImage) input.image = params.referenceImage.trim()
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
